import { Organization as OrganizationType } from "@/types/organization";
import { ApiResponse } from "@/types";
import { apiSlice } from "@/redux/apiSlice";
import { TaxType } from "@/types/enums";

export const Organization = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getOrgTaxType: builder.query<{ tax_type: TaxType }, number>({
        query: (org_id) => ({
          url: `/organizations/${org_id}/tax_type`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Organization","IncomeCategory","Invoice","Transaction","SysConfig"],
      }),
      getDashboard: builder.query<{ dashboard_url: string }, void>({
        query: () => ({
          url: `/dashboard-url`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Organization"],
      }),

      getOrganization: builder.query<OrganizationType, number>({
        query: (id) => ({
          url: `/organizations/${id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Organization"],
      }),

      updateOrganization: builder.mutation<ApiResponse, OrganizationType>({
        query: (organization) => ({
          url: `/organizations/${organization.id}`,
          method: "PUT",
          headers: {
            Accept: "application/json",
          },
          body: organization
        }),
        invalidatesTags: ["Organization"],
      }),
      deleteOrganization: builder.mutation<ApiResponse, number>({
        query: (id) => ({
          url: `/organizations/${id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Organization"],
      })
    };
  },
});

export const {
  useGetOrgTaxTypeQuery,
  useGetDashboardQuery,
  useGetOrganizationQuery,
  useUpdateOrganizationMutation,
  useDeleteOrganizationMutation
} = Organization;
